import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";

import {
  extractDTime,
} from "../ReusableComponents/UtilityFunctions";
import CommonDashBoard from "./CommonDashBoard";
import {
  getEmployeLeaveBalance,
  getEmployeeBirthDay,
  getEmployeeTime,
  getEmployeesPunchInCount,
  getLeaveAndAttendance,
  getWeekChartData,
  getWorkingDaysInThisMonthData,
} from "../../Services/DashboardServices";
import "./Dashboard.scss";

function CenterComponent() {
  const user = useSelector((state) => state.selectedActiveView.role);
  const employeeLogin = user === "employee";
  const adminLogin = user === "admin";

  const [absentData, setAbsentData] = useState([]);
  const [upComingAbsentData, setUpComingAbsentData] = useState([]);
  const [upComingBirthDay, setUpComingBirthDay] = useState([]);
  const [joiningAnniversaries, setJoiningAnniversaries] = useState([]);
  const [employeeInTime, setEmployeeInTime] = useState([]);
  const [employeeChartData, setEmployeeChartData] = useState([]);
  const [employeeWeekChartData, setEmployeeWeekChartData] = useState([]);
  const [workingDaysInThisMonth, setWorkingDaysInThisMonth] = useState([]);
  const [leaveBalanace, setLeaveBalanace] = useState([]);
  const [presentDaysData, setPresentDaysData] = useState([]);
  const [employeesCount, setEmployeesCount] = useState(0);
  const [punchInCount, setPunchInCount] = useState(0);

  const normalizeCheckInTime = (timerStart) => {
    if (!timerStart || timerStart === "12:00") {
      return null;
    }
    const parsedDate = new Date(timerStart);
    if (Number.isNaN(parsedDate.getTime())) {
      return null;
    }
    const hour = parsedDate.getHours().toString().padStart(2, "0");
    const minute = parsedDate.getMinutes().toString().padStart(2, "0");
    return `${hour}:${minute}`;
  };

  const memoizedGetLeaveAndAttendance = useMemo(() => {
    const getData = async () => {
      try {
        const response = await getLeaveAndAttendance();
        if (response.status === 200) {
          const validLeaveData = response.data.leaveData.filter(leave =>
            leave.status !== "Cancelled" && leave.status !== "Rejected"
          );
          const validUpcomingLeaves = response.data.nextLeaves.filter(leave =>
            leave.status !== "Cancelled" && leave.status !== "Rejected"
          );
          setAbsentData(validLeaveData);
          setUpComingAbsentData(validUpcomingLeaves);
        } else {
          setAbsentData([]);
          setUpComingAbsentData([]);
        }
      } catch (error) {
        console.error("Error fetching leave data:", error);
      }
    };
    return getData;
  }, []);

  const memoizedEmployeeTime = useMemo(() => {
    const getData = async () => {
      try {
        const response = await getEmployeeTime();
        if (response.status === 200) {
          const dataArray = response.data.dataArray;
          const normalizedData = dataArray.map((item) => ({
            ...item,
            normalizedTime: normalizeCheckInTime(item.TimerStart),
          }));

          const newdata = normalizedData.sort((a, b) => {
            if (!a.normalizedTime && b.normalizedTime) {
              return 1;
            }
            if (a.normalizedTime && !b.normalizedTime) {
              return -1;
            }
            if (!a.normalizedTime && !b.normalizedTime) {
              return 0;
            }
            return a.normalizedTime.localeCompare(b.normalizedTime);
          });

          setEmployeeInTime(newdata);
          const staticChartData = newdata?.map(
            ({ name, Time, normalizedTime }) => ({
              name,
              time: normalizedTime ?? "12:00",
              realTime: Time === "absent" ? "absent" : extractDTime(Time),
            })
          );
          setEmployeeChartData(staticChartData);
          if (employeesCount === 0) {
            setEmployeesCount(dataArray.length);
          }
        } else {
          setEmployeeInTime([]);
          setEmployeeChartData([]);
        }
      } catch (error) {
      }
    };
    return getData;
  }, [employeesCount]);

  // const memoizedEmployeeBirthDay = useMemo(() => {
  //   const getData = async () => {
  //     try {
  //       const response = await getEmployeeBirthDay();
  //       if (response.status === 200) {
  //         console.log("response.data", response.data)
  //         setEmployeesCount(response.data.employeesCount);
  //         setUpComingBirthDay(response.data.BirthDays);
  //       } else {
  //         setEmployeesCount(0);
  //         setUpComingBirthDay([]);
  //       }
  //     } catch (error) {
  //     }
  //   };
  //   return getData;
  // }, []);
  const memoizedEmployeeBirthDay = useMemo(() => {
    const getData = async () => {
      try {
        const response = await getEmployeeBirthDay();
        if (response.status === 200) {
          console.log("response.data", response.data);
          setEmployeesCount(response.data.employeesCount);
          setUpComingBirthDay(response.data.BirthDays);
          setJoiningAnniversaries(response.data.JoiningDate);
        } else {
          setEmployeesCount(0);
          setUpComingBirthDay([]);
          setJoiningAnniversaries([]);
        }
      } catch (error) {
        console.error("Error fetching birthdays and anniversaries", error);
      }
    };
    return getData;
  }, []);

  const memoizedEmployeLeaveBalance = useMemo(() => {
    const getData = async () => {
      try {
        const response = await getEmployeLeaveBalance();
        if (response.status === 200) {
          setLeaveBalanace(response.data.array);
        } else {
          setLeaveBalanace([]);
        }
      } catch (error) {
      }
    };
    return getData;
  }, []);

  const memoizedWorkingDaysInThisMonthData = useMemo(() => {
    const getWorkingDaysInThisMonth = async () => {
      try {
        const response = await getWorkingDaysInThisMonthData();
        if (response.status === 200) {
          setWorkingDaysInThisMonth(response.data.WorkingDaysInThisMonth);
          setPresentDaysData(response.data.PresentDaysData);
        } else {
          setWorkingDaysInThisMonth([]);
          setPresentDaysData([]);
        }
      } catch (error) {
      }
    };
    return getWorkingDaysInThisMonth;
  }, []);

  const memoizedWeekChartData = useMemo(() => {
    const getData = async () => {
      try {
        const response = await getWeekChartData();
        if (response.status === 200) {
          setEmployeeWeekChartData(response.data.weekData);
        } else {
          setEmployeeWeekChartData([]);
        }
      } catch (error) {
      }
    };
    return getData;
  }, []);

  const memoizedEmployeesPunchInCount = useMemo(() => {
    const getAdminData = async () => {
      try {
        const response = await getEmployeesPunchInCount();
        if (response.status === 200) {
          setPunchInCount(response.data.punchInCount);
        } else {
          setPunchInCount(0);
        }
      } catch (error) {
      }
    };
    return getAdminData;
  }, []);

  useEffect(() => {
    if (adminLogin || employeeLogin) {
      memoizedEmployeeBirthDay();
      memoizedEmployeLeaveBalance();
      memoizedEmployeesPunchInCount();
    }
  }, [
    adminLogin,
    employeeLogin,
    memoizedEmployeeBirthDay,
    memoizedEmployeLeaveBalance,
    memoizedEmployeesPunchInCount,
  ]);

  useEffect(() => {
    if (adminLogin) {
      memoizedEmployeeTime();
      memoizedWeekChartData();
    } else {
      // Ensure admin-only visuals are reset for non-admin roles.
      setEmployeeInTime([]);
      setEmployeeChartData([]);
      setEmployeeWeekChartData([]);
    }
  }, [adminLogin, memoizedEmployeeTime, memoizedWeekChartData]);

  useEffect(() => {
    if (adminLogin || employeeLogin) {
      memoizedWorkingDaysInThisMonthData();
      memoizedGetLeaveAndAttendance();
    }
  }, [
    adminLogin,
    employeeLogin,
    memoizedWorkingDaysInThisMonthData,
    memoizedGetLeaveAndAttendance,
  ]);

  return (
    <Box>
      <CommonDashBoard
        absentData={absentData}
        count={punchInCount}
        upComingAbsentData={upComingAbsentData}
        upComingBirthDay={upComingBirthDay}
        joiningAnniversaries={joiningAnniversaries}
        employeeInTime={employeeInTime}
        employeeChartData={employeeChartData}
        employeeWeekChartData={employeeWeekChartData}
        workingDaysInThisMonth={workingDaysInThisMonth}
        presentDaysData={presentDaysData}
        userData={employeesCount}
        leaveBalanace={leaveBalanace}
      />
    </Box>
  );
}

export default CenterComponent;
